interface TooltipProps {
  text: string
  className?: string
}

export const Tooltip = ({ text, className = '' }: TooltipProps) => {
  return (
    <div
      className={`relative inline-block w-fit bg-[#505050] text-white rounded-6 px-2 py-[6px] z-50 pointer-events-none ${className}`}
    >
      <p className="whitespace-nowrap">{text}</p>
      <div className="absolute top-[30px] left-[50%] -ml-1 size-2 bg-[#505050] rotate-45" />
    </div>
  )
}
